// eslint-disable-next-line
export default () => ({
  divWidth: {
    width: "inherit",
  },
  dimondIcon: {
    height: 6,
    width: 6,
    backgroundColor: "black",
    transform: "rotate(45deg)",
    "&:hover": {
      backgroundColor: "#26BBED",
    },
  },
  alignMent: {
    textAlign: "-webkit-center !important",
  },
  iconRotate: {
    transform: "rotate(180deg)",
  },
  topContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "14px",
    height: 24,
  },
  leftContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    fontSize: "14px",
    lineHeight: "20px",
    width: 200,
  },
  rightContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "14px",
    width: 80,
  },
  leftMargin: {
    marginRight: 2,
  },
  monthView: {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    "&:hover": {
      color: "#26bbed",
    },
    "&:hover path": {
      stroke: "#26bbed",
    },
  },
  yearView: {
    marginLeft: 8,
    width: 70,
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    "&:hover": {
      color: "#26bbed",
    },
    "&:hover path": {
      stroke: "#26bbed",
    },
  },
});
